const { parse } = require("./template-parser");
const { traverse } = require("./traverser");
module.exports = {
  parse,
  traverse,
};
